<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <img-with-loading
    :height="'36px'"
    :img-src="root+item[model]"
    :width="'36px'"
  />
</template>

<script>
import ImgWithLoading from './ImgWithLoading.vue'

export default {
  name: 'ImgTemplate',
  components: { ImgWithLoading },
  props: {
    root: {
      type: String,
      default: '/'
    },
    item: {
      type: Object,
      default: null
    },
    model: {
      type: String,
      default: 'photo'
    }

  }
}
</script>

<style scoped>

</style>
